export default "__VITE_ASSET__10312f4d__$_?component__"